import MostActiveTickers from './MostActiveTickers';
export default MostActiveTickers;
